export default (context, inject) => {
  const { store } = context;

  const processImpressions = async () => {
    const { impressions = {} } = store.state;
    const { dealIds = [] } = impressions;

    if (!dealIds || !Array.isArray(dealIds)) {
      store.commit('impressions/reset');
      return;
    }

    try {
      store.commit('impressions/reset');

      if (!dealIds || !dealIds.length) return;

      const uniqueIds = [...new Set(dealIds)];

      const bug = new Image();
      bug.src = `/deal/impression/?deal_ids=${uniqueIds.join('|')}`;
      bug.alt = '';
      bug.style.display = 'none';
      bug.addEventListener('load', () => { bug.parentNode.removeChild(bug); }, { once: true });
      bug.addEventListener('error', () => { bug.parentNode.removeChild(bug); }, { once: true });

      document.body.appendChild(bug);
    } catch (err) {
      store.commit('impressions/reset');
      // eslint-disable-next-line
      console.log('Error Parsing Impressions:', err);
    }
  };

  // Add an impressions
  const add = (dealId) => {
    const { impressions = {} } = store.state;
    const { interval } = impressions;

    if (!interval) {
      const intervalId = setInterval(processImpressions, 1000);
      store.commit('impressions/interval', intervalId);
    }

    store.commit('impressions/add', dealId);
  };

  // Remove all activities
  const reset = () => {
    store.commit('impressions/reset');
  };

  const impressions = {
    add,
    reset,
  };

  inject('impressions', impressions);
  context.$impressions = impressions;
};
